<div class="mct-flex mct-row mct-wrap mct-justify-between mct-items-stretch"   [ngClass]="isEditable ? 'invoice-summary' : 'invoice-summary border'">
  <div class="mct-flex mct-row mct-wrap mct-gap-54"   [ngClass]="isEditable ? 'invoice-summary-amounts border' : 'invoice-summary-amounts'">
    <div class="mct-flex mct-col" >
      <div class="card-field-label">{{ 'invoices.invoice-builder.invoice-summary.invoice-num' | translate | ucfirst }}</div>
      <div class="f-wb value-box">{{ invoice.InvoiceHeader.InvoiceNum }}</div>
    </div>
    <div class="mct-flex mct-col" >
      <div class="card-field-label">{{ 'invoices.invoice-builder.invoice-summary.total-cost' | translate | ucfirst }}</div>
      <div [ngClass]="relatedModification ? 'value-box-green' : 'value-box'">{{ invoiceTotal | currency }}</div>
    </div>
    <div class="mct-flex mct-col" >
      <div class="card-field-label">{{ 'invoices.invoice-builder.invoice-summary.amount-paid' | translate | ucfirst }}</div>
      <div class="f-wb value-box">{{ paymentTotal | currency }}</div>
    </div>
    <div class="mct-flex mct-col" >
      <div class="card-field-label">{{ 'invoices.invoice-builder.invoice-summary.balance' | translate | ucfirst }}</div>
      <div [ngClass]="relatedModification ? 'f-wb value-box-green' : 'value-box f-wb'">{{ balance | currency }}</div>
    </div>
  </div>
  <div class="mct-flex mct-row mct-flex-lt-sm mct-row-lt-sm mct-wrap-lt-sm mct-gap-7"   >
    <div class="mct-flex mct-col" >
      <div class="card-field-label">{{ 'invoices.invoice-builder.invoice-summary.due-date' | translate | ucfirst }}</div>
      <wl-date-selector #dateDueSelector *ngIf="isEditable" [(ngModel)]="invoice.InvoiceHeader.DateDue"></wl-date-selector>
      <div *ngIf="!isEditable" class="mr-50 f-wb value-box">{{ invoice.InvoiceHeader.DateDue | date: 'MM/dd/yyyy' }}</div>
    </div>
    <div class="mct-flex mct-col" >
      <div class="card-field-label">{{ 'invoices.invoice-builder.invoice-summary.invoice-date' | translate | ucfirst }}</div>
      <wl-date-selector #invoiceDateSelector *ngIf="isEditable" [(ngModel)]="invoice.InvoiceHeader.InvoiceDate"></wl-date-selector>
      <div *ngIf="!isEditable" class="f-wb value-box">{{ invoice.InvoiceHeader.InvoiceDate | date: 'MM/dd/yyyy' }}</div>
    </div>
  </div>
</div>
